import type { FC, PropsWithChildren } from 'react';

const BaseCard: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="mx-auto md:m-auto flex flex-col items-start gap-4 max-w-[588px] w-full flex-grow md:flex-grow-0">
      <div className="h-[1px] w-full bg-1xbet-gray-200 md:hidden" />
      <div className="w-full md:shadow-fonbet-card md:p-12 rounded-xsmall flex flex-col flex-grow md:flex-grow-0">
        {children}
      </div>
    </div>
  );
};

export { BaseCard };
